export default "__VITE_ASSET__D72hO_Z1__"